"use client";

import { createContext, type PropsWithChildren, useContext } from "react";
import type { CategorySources, PLPPage } from "../types";
import { usePLPListingQuery } from "./usePLPListingQuery";

type PLPQuery = ReturnType<typeof usePLPListingQuery>;

const PLPContext = createContext<PLPQuery | null>(null);

export const PLPProvider = ({
	initialPage,
	categorySources,
	searchQuery,
	forceClientFetch,
	preview,
	children,
}: PropsWithChildren<{
	initialPage: PLPPage;
	categorySources: CategorySources;
	searchQuery?: string;
	forceClientFetch?: boolean;
	preview?: boolean;
}>) => {
	const query = usePLPListingQuery({
		initialPage,
		categorySources,
		searchQuery,
		forceClientFetch,
		preview,
	});
	return <PLPContext.Provider value={query}>{children}</PLPContext.Provider>;
};

export const usePLP = () => {
	const ctx = useContext(PLPContext);
	if (!ctx) throw new Error("usePLP must be used within a PLPProvider");
	return ctx;
};
